import styled from 'styled-components';
import { media } from '@bitcoin-portal/bitcoincom-pkg-theme';
import Section from '@bitcoin-portal/bitcoincom-pkg-components/dist/Section';

export const StyledSection = styled(Section)`
  order: 5;
  margin: 40px 0px 0px !important;
  padding: 0px 20px !important;

  ${media.md`
    margin: 80px 0px 0px !important;
    padding: 0px 60px !important;
  `}

  ${media.xl`
    max-width: 1060px !important;
    margin: 100px auto 0px !important;
    padding: 0px !important;
  `}
`;

export const StyledContentBlock = styled.div`
  display: flex !important;
  flex-direction: column !important;
  align-items: center;
  padding: 0px !important;
`;

export const MainTitle = styled.h2`
  color: #1c1c1c;
  font-family: 'Elza Condensed', sans-serif;
  font-size: 50px;
  font-weight: 900;
  line-height: 87%;
  letter-spacing: -1px;
  text-align: center;
  text-transform: uppercase;
  margin: 0px;

  ${media.xl`
    font-size: 90px;
    font-weight: 900;
    line-height: 90%;
    letter-spacing: -1.8px;
  `}
`;
